// Component: src/theme/snippets/menu-drawer.liquid

const MENU_DRAWER_BUTTON_ID = "header-menu-button";
const MENU_DRAWER_ID = "menu-drawer";
const MENU_DRAWER_OVERLAY_ID = "menu-drawer-overlay";
const MENU_DRAWER_CLOSE_BUTTON_ID = "menu-drawer-close-button";

document.getElementById(MENU_DRAWER_BUTTON_ID)?.addEventListener("click", function () {
  openMenuDrawer();
});

document.getElementById(MENU_DRAWER_OVERLAY_ID)?.addEventListener("click", function () {
  closeMenuDrawer();
});

document.getElementById(MENU_DRAWER_CLOSE_BUTTON_ID)?.addEventListener("click", function () {
  closeMenuDrawer();
});

function openMenuDrawer() {
  const menuDrawer = document.getElementById(MENU_DRAWER_ID);
  menuDrawer?.classList.remove("closed");
  menuDrawer?.classList.add("open");
  document.getElementById(MENU_DRAWER_OVERLAY_ID)?.classList.add("open");
  document.querySelector("body")?.classList.add("no-scroll");
}

export function closeMenuDrawer() {
  const menuDrawer = document.getElementById(MENU_DRAWER_ID);
  menuDrawer?.classList.remove("open");
  menuDrawer?.classList.add("closed");
  document.getElementById(MENU_DRAWER_OVERLAY_ID)?.classList.remove("open");
  document.querySelector("body")?.classList.remove("no-scroll");
}

export function isOpen() {
  return document.getElementById(MENU_DRAWER_ID)?.classList.contains("open");
}
